import axios from "./axios.interceptors";
import { ActiveUserResponse } from "app/types/service-types/ActiveUsersTypes";
class ActiveUsersService {
  async getOnlineUsers(): Promise<ActiveUserResponse[]> {
    const response = await axios.get("/api/admin/active-users");
    return response.data;
  }
}

export default new ActiveUsersService();
